/**
 * 底部
 * Created at 2021-10-02 00:23
 * @author teapot
 */
import { useTranslation } from "react-i18next";
import "./index.css";
import { useHistory } from "react-router";
import address from "./images/address.png";
import phone from "./images/phone.png";
import fax from "./images/fax.png";
import email from "./images/email.png";
import Api from "../../api";
import { DetailsParams } from "../../model/HomeModel";

const FootView = ({ index }: { index?: boolean }) => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <>
      {/* PC 适配 */}
      <div className="footer footer-styles footer-pc">
        <div className="footer-left footer-placeholder">
          {/* 第一列 */}
          <div className="footer-left-item footer-left-text">
            <div className="footer-item-title">{t("nav_us")}</div>
            {/* <span  className='cursor'>{t('nav_us_synopsis')}</span> */}
            <span
              className="cursor"
              onClick={() => {
                let path = window.btoa(
                  JSON.stringify({
                    url: Api.outlook,
                    uuid: "111",
                    methods: "get",
                    bottom: true,
                  })
                );
                history.push(`/about-us/mission&convener_statement/${path}`, {
                  url: Api.outlook,
                  uuid: "111",
                  methods: "get",
                  bottom: true,
                });
              }}
            >
              {t("nav_us_outlook")}
            </span>

            <span
              className="cursor"
              onClick={() => {
                history.push("/about-us/advisory_board ");
              }}
            >
              {t("nav_us_adviser")}
            </span>

            <span
              className="cursor"
              onClick={() => {
                history.push("/about-us/member");
              }}
            >
              {t("nav_us_think_tank")}
            </span>

            <span
              className="cursor"
              onClick={() => {
                history.push("/about-us/join-us");
              }}
            >
              {t("nav_us_join")}
            </span>
            <span
              className="cursor"
              onClick={() => {
                history.push("/about-us/contact-us");
              }}
            >
              {t("nav_us_contact")}
            </span>
            <span
              className="cursor"
              onClick={() => {
                history.push("/about-us/related_links");
              }}
            >
              {t("nav_us_link")}
            </span>
          </div>
          {/* 第二列 */}
          <div className="footer-left-item footer-left-text">
            <div
              className="footer-item-title"
              onClick={() => {
                history.push("/newsroom/media_coverage");
              }}
            >
              {t("nav_multimedia")}
            </div>
            <span
              className="cursor"
              onClick={() => {
                history.push("/newsroom/media_coverage");
              }}
            >
              {t("nav_multimedia_media")}
            </span>
            <span
              className="cursor"
              onClick={() => {
                history.push("/newsroom/press-releases");
              }}
            >
              {t("nav_multimedia_news")}
            </span>

            <div style={{ marginTop: "2px" }} className=" footer-item-title ">
              {" "}
              <span> {t("nav_policy")}</span>
            </div>
            <span
              className="cursor"
              onClick={() => {
                history.push("/login");
              }}
            >
              {t("policy_book")}
            </span>
            <span
              className="cursor"
              onClick={() => {
                history.push("/login");
              }}
            >
              {t("policy_review")}
            </span>
          </div>
          {/* 第三列 */}
          <div className="footer-left-item footer-left-text">
            <div
              className="footer-placeholder"
              onClick={() => {
                history.push("/whats_on_neg");
              }}
            >
              <span className="cursor">{t("nav_report")}</span>
            </div>
            <div
              style={{ marginTop: "-70px" }}
              className="footer-placeholder"
              onClick={() => {
                history.push("/commentary");
              }}
            >
              {" "}
              <span className="cursor">{t("nav_member")}</span>{" "}
            </div>
          </div>
        </div>

        <div className="footer-v-line" />

        <div className="footer-right footer-left-item ">
          <div className="footer-rightitem-title">{t("footer_contact_us")}</div>
          <span className="footer-rightitem-content">
            <img src={address} alt="1" />
            {t("footer_contact_address")}
          </span>
          <span className="footer-rightitem-content">
            <img src={phone} alt="" />
            {t("footer_contact_phone")}
          </span>
          <span className="footer-rightitem-content">
            <img src={fax} alt="" />
            {t("footer_contact_fax")}
          </span>
          <span className="footer-rightitem-content">
            <img src={email} alt="" />
            {t("footer_contact_email")}
          </span>
        </div>
      </div>

      <div style={index ? { display: "none" } : {}}>
        {/* 手机适配 */}
        <div className="footer footer-styles footer-phone">
          <div className="footer-left footer-placeholder">
            {/* 第一列 */}
            <div className="footer-left-item footer-left-text">
              <div className="footer-item-title">{t("nav_us")}</div>
              {/* <span  className='cursor'>{t('nav_us_synopsis')}</span> */}
              <span
                className="cursor"
                onClick={() => {
                  let path = window.btoa(
                    JSON.stringify({
                      url: Api.outlook,
                      uuid: "111",
                      methods: "get",
                      bottom: true,
                    })
                  );
                  history.push(`/about-us/mission&convener_statement/${path}`, {
                    url: Api.outlook,
                    uuid: "111",
                    methods: "get",
                    bottom: true,
                  });
                }}
              >
                {t("nav_us_outlook")}
              </span>

              <span
                className="cursor"
                onClick={() => {
                  history.push("/about-us/advisory_board ");
                }}
              >
                {t("nav_us_adviser")}
              </span>

              <span
                className="cursor"
                onClick={() => {
                  history.push("/about-us/member");
                }}
              >
                {t("nav_us_think_tank")}
              </span>

              <span
                className="cursor"
                onClick={() => {
                  history.push("/about-us/join-us");
                }}
              >
                {t("nav_us_join")}
              </span>
              <span
                className="cursor"
                onClick={() => {
                  history.push("/about-us/contact-us");
                }}
              >
                {t("nav_us_contact")}
              </span>
              <span
                className="cursor"
                onClick={() => {
                  history.push("/about-us/related_links");
                }}
              >
                {t("nav_us_link")}
              </span>
            </div>
            {/* 第二列 */}
            <div className="footer-left-item footer-left-text">
              <div
                className="footer-item-title"
                onClick={() => {
                  history.push("/newsroom/media_coverage");
                }}
              >
                {t("nav_multimedia")}
              </div>
              <span
                className="cursor"
                onClick={() => {
                  history.push("/newsroom/media_coverage");
                }}
              >
                {t("nav_multimedia_media")}
              </span>
              <span
                className="cursor"
                onClick={() => {
                  history.push("/newsroom/press-releases");
                }}
              >
                {t("nav_multimedia_news")}
              </span>

              <div style={{ marginTop: "2px" }} className=" footer-item-title ">
                {" "}
                <span> {t("nav_policy")}</span>
              </div>
              <span
                className="cursor"
                onClick={() => {
                  history.push("/login");
                }}
              >
                {t("policy_book")}
              </span>
              <span
                className="cursor"
                onClick={() => {
                  history.push("/login");
                }}
              >
                {t("policy_review")}
              </span>
            </div>
            {/* 第三列 */}
            <div className="footer-left-item footer-left-text">
              <div
                className="footer-placeholder"
                onClick={() => {
                  history.push("/whats_on_neg");
                }}
              >
                <span className="cursor">{t("nav_report")}</span>
              </div>
              <div
                style={{ marginTop: "-70px" }}
                className="footer-placeholder"
                onClick={() => {
                  history.push("/commentary");
                }}
              >
                {" "}
                <span className="cursor">{t("nav_member")}</span>{" "}
              </div>
            </div>
          </div>

          <div className="footer-v-line" />

          <div className="footer-right footer-left-item ">
            <div className="footer-rightitem-title">
              {t("footer_contact_us")}
            </div>
            <span className="footer-rightitem-content">
              <img src={address} alt="1" />
              {t("footer_contact_address")}
            </span>
            <span className="footer-rightitem-content">
              <img src={phone} alt="" />
              {t("footer_contact_phone")}
            </span>
            <span className="footer-rightitem-content">
              <img src={fax} alt="" />
              {t("footer_contact_fax")}
            </span>
            <span className="footer-rightitem-content">
              <img src={email} alt="" />
              {t("footer_contact_email")}
            </span>
          </div>
        </div>

        <div className="footer footer-title footer-bgcolor">
          <div>{t("footer_title")}</div>
          <div>{t("footer_title2")}</div>
        </div>
      </div>
    </>
  );
};

export default FootView;
